import { InputBase } from './input-base';
/**
 * NumberInput Component.
 */
export class NumberInput extends InputBase<string>{
    controlType = 'number';
}